import React, {useId, useState} from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import './InputField.css';
import Message from './Message';

const InputField = React.forwardRef(({ message, hideMessage, ...rest }, ref) => {
  const messageId = useId();
  const fileInputId = useId();
  const [fileName, setFileName] = useState('');
  const isInvalid = !!message?.content;

  const ariaDescribedBy = hideMessage ? {} : { 'aria-describedby': messageId };

  const inputType = rest.type || "text";
  const { onChange, id, ...inputProps } = rest;

  if (inputType === 'file') {
    const inputId = id || fileInputId;
    const fileLabel = rest['aria-label'] || 'Choose file';
    const handleFileChange = (event) => {
      setFileName(event.target.files?.[0]?.name || '');
      onChange?.(event);
    };

    return (
      <>
        <div className="file-input-control">
          <label className="file-input-button" htmlFor={inputId}>{fileLabel}</label>
          <span className="file-input-name">{fileName || 'No file chosen'}</span>
          <Form.Control
            ref={ref}
            id={inputId}
            type="file"
            onChange={handleFileChange}
            aria-invalid={isInvalid}
            { ...ariaDescribedBy }
            { ...inputProps }
          />
        </div>
        {!hideMessage && <Message messageId={messageId} type={message?.type}>{message?.content}</Message>}
      </>
    );
  }

  return (
    <>
      <Form.Control ref={ref} type={inputType} aria-invalid={isInvalid} { ...ariaDescribedBy } onChange={onChange} { ...inputProps } />
      {!hideMessage && <Message messageId={messageId} type={message?.type}>{message?.content}</Message>}
    </>
  );
});

InputField.propTypes = {
  message: PropTypes.shape({
    content: PropTypes.string,
    type: PropTypes.oneOf(['light', 'neutral', 'warning'])
  }),
  hideMessage: PropTypes.bool
};

export default InputField;
